import { Component, OnInit } from '@angular/core';
import { GlobalService } from '@core/services';
import { ContactUsService } from '@core/services/contact.service';

@Component({
  selector: 'app-news',
  templateUrl: './news.component.html',
  styleUrls: ['./news.component.scss'],
})

export class NewsComponent implements OnInit {
  AllNews: any;
  p=0;
  paginate:any;

  constructor(
    private contactService: ContactUsService,
  ) { }

  ngOnInit(): void {
    this.getAllNews();
  }
  getAllNews(start = 0) {
    this.contactService.getNews((start),120).subscribe(res => {
      if (res) {
        this.AllNews = res.Object.objects;
      }
    }, err => {
    });
  }

  search(event: any) {
    this.contactService.getNews(0,120,event.target.value).subscribe(res => {
      if (res)
      this.AllNews = res.Object.objects;
    }, err => {
    });
  }
}
